// src/pages/SuppliersPage.js
import React, { useState } from "react";
import { useParams, useNavigate, useSearchParams } from "react-router-dom";
import { useEffect } from "react";
import PageHeader from "../components/ui/PageHeader";
import SupplierList from "../components/suppliers/SupplierList";
import SupplierForm from "../components/suppliers/SupplierForm";
import SupplierDetail from "../components/suppliers/SupplierDetail";
import { Box, Button, Dialog, DialogContent, useTheme } from "@mui/material";
import { Add } from "@mui/icons-material";

const SuppliersPage = () => {
  const { supplierId } = useParams();
  const navigate = useNavigate();
  const theme = useTheme();
  const [showForm, setShowForm] = useState(false);
  const [editingSupplier, setEditingSupplier] = useState(null);
  const [refreshKey, setRefreshKey] = useState(0);
  const [searchParams] = useSearchParams();

  useEffect(() => {
    if (searchParams.get("new") === "true") {
      setShowForm(true);
    }
  }, []);

  const handleView = (supplier) => {
    navigate(`/suppliers/${supplier.id}`);
  };

  const handleEdit = (supplier) => {
    setEditingSupplier(supplier);
    setShowForm(true);
  };

  const handleSave = () => {
    setShowForm(false);
    setEditingSupplier(null);
    setRefreshKey((k) => k + 1);
  };

  if (supplierId) {
    return <SupplierDetail supplierId={supplierId} onEdit={handleEdit} />;
  }

  return (
    <Box>
      <PageHeader
        title="Proveedores"
        action={
          <Button
            variant="contained"
            startIcon={<Add />}
            onClick={() => {
              setEditingSupplier(null);
              setShowForm(true);
            }}
            sx={{
              background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.dark} 100%)`,
              borderRadius: "12px",
              textTransform: "none",
              fontWeight: 600,
              boxShadow: 'none',
              '&:hover': {
                boxShadow: `0 4px 12px ${theme.palette.warning.main}40`,
                filter: 'brightness(1.05)',
              },
            }}
          >
            Nuevo Proveedor
          </Button>
        }
      />
      <SupplierList key={refreshKey} onView={handleView} onEdit={handleEdit} />

      <Dialog
        key={editingSupplier?.id || "new"}
        open={showForm}
        onClose={() => {
          setShowForm(false);
          setEditingSupplier(null);
        }}
        maxWidth="md"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: "24px",
            maxHeight: "90vh",
          },
        }}
      >
        <DialogContent sx={{ p: 0 }}>
          <SupplierForm
            supplier={editingSupplier}
            onSave={handleSave}
            onCancel={() => {
              setShowForm(false);
              setEditingSupplier(null);
            }}
          />
        </DialogContent>
      </Dialog>
    </Box>
  );
};

export default SuppliersPage;